import React, { Component } from 'react';
import Button from "./Button";
import DisplayCard from "./DisplayCard";
import { Helmet } from "react-helmet";

class CheckoutEnvelope extends Component {
    render() {
        const { handleEnvelope, 
            validateCartFinal, 
            envelopes, 
            goToPrevious, 
            envelope_error, 
            envelope, 
            valid,
            scripts_pick_envelope,
            envelope_number_color,
            envelope_background_image,
            envelopeBackgroundImageHeight } = this.props;
        return (
            <div className="flex flex-wrap justify-center mb-6">
                <Helmet>
                    {scripts_pick_envelope && <script>{scripts_pick_envelope}</script>}
                </Helmet>
                {envelopes.map((value, key) => (
                    <DisplayCard
                        envelopeNumberColor={envelope_number_color}
                        envelopeBackgroundImage={envelope_background_image}
                        envelopeBackgroundImageHeight={envelopeBackgroundImageHeight}
                        key={key}
                        cardInfo={value}
                        clickHandler={handleEnvelope}
                        envelope={envelope} />
                ))}
                {envelope_error && (
                    <div className="w-full flex justify-center mt-6">
                        <div className="bg-white border border-danger text-danger px-4 py-3 rounded relative" role="alert">
                            {
                                envelope_error &&
                                <i className="block md:inline font-bold">{valid.envelope}</i>
                            }
                        </div>
                    </div>
                )}
                <div className="w-full mt-10 flex flex-wrap justify-between justify-center">
                    <Button onClick={goToPrevious} color="secondary" textColor="primary" content={"Back"} />
                    <Button color="accent" textColor="primary" onClick={validateCartFinal} content={"Continue"} continueButton="true"/>
                </div>
            </div>
        );
    }
}

export default CheckoutEnvelope;
